module.exports = __webpack_public_path__ + "static/media/Down_Arrow_Blue.a1a8667c.svg";